module.exports = __webpack_public_path__ + "static/media/show.b45cae1a.svg";